export default __webpack_public_path__ + "static/media/instruction-icon.93353679.svg";